import React, { useState } from 'react'

import { useParams } from 'react-router-dom'

import Notifications from '../../../../../presentation/pages/common/notifications'

import { useResource } from '../../../../../presentation/hooks/resource'
import { useFetchResources } from '../../../../../presentation/hooks/fetch-resources'

import { makeNotifications } from '../../../../usecases/notifications/remote-notifications-factory'

import INotification from '../../../../../presentation/interfaces/notification'

const MakeNotifications = () => {
  const [search, setSearch] = useState('')

  const [resource, resourceService] = useResource<INotification>(
    makeNotifications(),
  )

  const { type } = useParams<{ type: string }>()

  useFetchResources(resourceService.load, {
    type,
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value)
  }

  const handleSearch = () => {
    resourceService.load({
      type,
      search,
    })
  }

  document.title = `BuscarMédicos - Notificações - ${type}`

  const notificationsProps = {
    states: {
      search,
      resource,
    },
    handlers: {
      handleChange,
      handleSearch,
    },
  }

  return <Notifications {...notificationsProps} />
}

export default MakeNotifications
